export default __webpack_public_path__ + "static/media/compass.f917f047.svg";